<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import { mapGetters } from 'vuex'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getProjectDomainFilter, getDescriptionFilter } from '@/utils/common/tableFilter'
import GlobalSearchMixin from '@/mixins/globalSearch'
import {
  getNameDescriptionTableColumn,
  getTagTableColumn,
} from '@/utils/common/tableColumn'

export default {
  name: 'DomainList',
  mixins: [WindowsMixin, ListMixin, GlobalSearchMixin],
  props: {
    id: String,
    organization: {
      require: true,
      type: Object,
    },
    currentNode: Object,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'OrgDomainList',
        getParams: this.getParams,
        resource: 'domains',
        apiVersion: 'v1',
        filterOptions: {
          id: {
            label: this.$t('table.title.id'),
          },
          name: {
            label: this.$t('system.text_101'),
            filter: true,
            formatter: val => {
              return `name.contains("${val}")`
            },
          },
          description: getDescriptionFilter(),
          project_domain: getProjectDomainFilter(),
        },
        hiddenColumns: ['created_at'],
      }),
      singleActions: [
        {
          label: this.$t('iamee.remove_someone', [this.$t('dictionary.domain')]),
          permission: 'organization_nodes_perform_unbind',
          action: (obj) => {
            this.createDialog('OrganizationUnbindDialog', {
              type: 'domain',
              orgNodeId: this.currentNode.id,
              targets: [obj],
              columns: [
                {
                  field: 'levelName',
                  title: this.$t('iamee.level_desc'),
                },
                {
                  field: 'name',
                  title: this.$t('table.title.name'),
                },
                {
                  field: 'parentName',
                  title: this.$t('iamee.parent_organization'),
                },
              ],
              data: this.currentNode.name ? [this.currentNode] : [],
              name: this.$t('dictionary.domain'),
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              validate: this.currentNode.id !== 'root',
            }
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['globalConfig']),
    groupActions () {
      const actions = [
        {
          label: this.$t('iamee.add_someone', [this.$t('dictionary.domain')]),
          permission: 'organizations_perform_bind',
          action: () => {
            this.createDialog('OrganizationBindDialog', {
              type: 'domain',
              columns: [
                {
                  field: 'levelName',
                  title: this.$t('iamee.level_desc'),
                },
                {
                  field: 'name',
                  title: this.$t('table.title.name'),
                },
                {
                  field: 'parentName',
                  title: this.$t('iamee.parent_organization'),
                },
              ],
              data: this.currentNode.name ? [this.currentNode] : [],
              name: this.$t('dictionary.domain'),
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
              validate: this.currentNode.id !== 'root',
            }
          },
        },
        {
          label: this.$t('iamee.remove_someone', [this.$t('dictionary.domain')]),
          permission: 'organization_nodes_perform_unbind',
          action: () => {
            this.createDialog('OrganizationUnbindDialog', {
              type: 'domain',
              orgNodeId: this.currentNode.id,
              targets: this.list.selectedItems,
              columns: [
                {
                  field: 'levelName',
                  title: this.$t('iamee.level_desc'),
                },
                {
                  field: 'name',
                  title: this.$t('table.title.name'),
                },
                {
                  field: 'parentName',
                  title: this.$t('iamee.parent_organization'),
                },
              ],
              data: this.currentNode.name ? [this.currentNode] : [],
              name: this.$t('dictionary.domain'),
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              validate: this.list.selectedItems.length > 0 && this.currentNode.id !== 'root',
            }
          },
        },
      ]
      return actions
    },
    columns () {
      const ret = [
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          hideField: true,
          edit: false,
          editDesc: false,
          slotCallback: row => {
            return (
              <side-page-trigger>{ row.name }</side-page-trigger>
            )
          },
        }),
        getTagTableColumn({
          onManager: this.onManager,
          resource: 'domains',
          params: { service: 'identity' },
          columns: () => this.columns,
          tipName: this.$t('dictionary.domain'),
          editCheck: () => false,
        }),
      ]
      const { tags = [] } = this.currentNode
      tags.map((item, index) => {
        ret.push({
          field: `tag_${index + 1}`,
          title: item.key.replace('org:', ''),
          minWidth: '100px',
          formatter: ({ row }) => {
            return item.value
          },
        })
      })
      return ret
    },
    exportDataOptions () {
      return {
        downloadType: 'local',
        title: this.$t('dictionary.domain'),
        items: this.columns,
      }
    },
  },
  watch: {
    'currentNode.tags': {
      handler: function (val) {
        this.list.fetchData()
      },
      immediate: true,
      deep: true,
    },
  },
  created () {
  },
  methods: {
    refresh () {
      this.list.refresh()
    },
    getParams () {
      const ret = {}
      if (this.currentNode.tags) {
        this.currentNode.tags.map((item, index) => {
          ret[`tags.${index}.key`] = item.key
          ret[`tags.${index}.value`] = item.value
        })
      }
      return ret
    },
    handleOpenSidepage (row, tab) {
      this.sidePageTriggerHandle(this, 'DomainSidePage', {
        id: row.id,
        resource: 'domains',
        apiVersion: 'v1',
        getParams: this.getParams,
      }, {
        list: this.list,
        tab,
      })
    },
  },
}
</script>
